export function getPaddingClasses(padding) {
  return {
    xs: 'px-1 py-1',
    sm: 'px-2 py-2 first:pl-4 last:pr-4',
    md: 'px-3 py-2 first:pl-6 last:pr-6',
    lg: 'px-6 py-3',
    xl: 'px-6 py-4',
  }[padding]
}

export function getHeadingPaddingClasses(padding) {
  return {
    xs: 'px-1 py-3.5',
    sm: 'px-2 py-3.5 first:pl-4 last:pr-4',
    md: 'px-3 py-3.5 first:pl-6 last:pr-6',
    lg: 'px-6 py-3.5',
    xl: 'px-6 py-4',
  }[padding]
}

export function getGroupPaddingClasses(padding) {
  return {
    xs: 'px-1 py-1',
    sm: 'px-2 py-1 first:pl-4 last:pr-4',
    md: 'px-3 py-1 first:pl-6 last:pr-6',
    lg: 'px-6 py-2',
    xl: 'px-6 py-3',
  }[padding]
}
